import { render, staticRenderFns } from "./c-actual@.vue?vue&type=template&id=6f046047&scoped=true&"
import script from "./c-actual@.vue?vue&type=script&lang=ts&"
export * from "./c-actual@.vue?vue&type=script&lang=ts&"
import style0 from "./c-actual@.vue?vue&type=style&index=0&id=6f046047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f046047",
  null
  
)

export default component.exports